//src/services/api.js
import API from "./interceptor";

// ******************* Get all user *******************
export const getAllUser = async (queryParams = {}) => {
  try {
    const response = await API.get(`/api/user`, { params: queryParams });
    return response.data;
  } catch (error) {
    throw error?.response?.data?.message || "Failed to fetch pets";
  }
};

// ******************* Get single user by ID *******************
export const getUserById = async (petId) => {
  try {
    const response = await API.get(`/api/user/${petId}`);
    return response.data;
  } catch (error) {
    throw error?.response?.data?.message || "Failed to fetch pet";
  }
};

// ******************* Get single user by Email *******************
export const getUserByEmail = async (email) => {
  try {
    const response = await API.get(
      `/api/user?email=${encodeURIComponent(email)}`
    );
    return response.data;
  } catch (error) {
    throw error?.response?.data?.message || "Failed to fetch user by email";
  }
};

// ******************* Update user information by Email *******************
export const updateUserByEmail = async (email, updateData) => {
  try {
    const response = await API.put(
      `/api/user?email=${encodeURIComponent(email)}`,
      updateData
    );
    return response.data;
  } catch (error) {
    throw error?.response?.data?.message || "Failed to update user";
  }
};

// ******************* Update user information by ID *******************
export const updateUser = async (userId, updateData) => {
  try {
    const response = await API.put(`/api/user/${userId}`, updateData);
    return response.data;
  } catch (error) {
    throw error?.response?.data?.message || "Failed to update user";
  }
};
// ******************* Create new pet *******************
export const createPet = async (petData) => {
  try {
    const response = await API.post(`/api/pets`, petData);
    return response.data;
  } catch (error) {
    throw error?.response?.data?.message || "Failed to create pet";
  }
};

// ******************* Get all pets with filtering and pagination *******************
export const getAllPets = async (queryParams = {}) => {
  try {
    const response = await API.get(`/api/pets`, { params: queryParams });
    return response.data;
  } catch (error) {
    throw error?.response?.data?.message || "Failed to fetch pets";
  }
};

// ******************* Get single pet by ID *******************
export const getPetById = async (petId) => {
  try {
    const response = await API.get(`/api/pets/${petId}`);
    return response.data;
  } catch (error) {
    throw error?.response?.data?.message || "Failed to fetch pet";
  }
};

// ******************* Update pet information *******************
export const updatePet = async (petId, updateData) => {
  try {
    const response = await API.put(`/api/pets/${petId}`, updateData);
    return response.data;
  } catch (error) {
    throw error?.response?.data?.message || "Failed to update pet";
  }
};

// ******************* Delete pet *******************
export const deletePet = async (petId) => {
  try {
    const response = await API.delete(`/api/pets/${petId}`);
    return response.data;
  } catch (error) {
    throw error?.response?.data?.message || "Failed to delete pet";
  }
};

// Update the addMedicalHistory function
export const addMedicalHistory = async (petId, medicalData) => {
  try {
    const response = await API.post(
      `/api/pets/${petId}/medical-history`,
      medicalData
    );
    return response.data;
  } catch (error) {
    throw error?.response?.data?.message || "Failed to add medical history";
  }
};

// Add the missing functions
export const getMedicalHistory = async (petId) => {
  try {
    const response = await API.get(`/api/pets/${petId}/medical-history`);
    return response.data;
  } catch (error) {
    throw error?.response?.data?.message || "Failed to get medical history";
  }
};

export const updateMedicalHistory = async (petId, medicalData) => {
  try {
    const response = await API.put(
      `/api/pets/${petId}/medical-history`,
      medicalData
    );
    return response.data;
  } catch (error) {
    throw error?.response?.data?.message || "Failed to update medical history";
  }
};
// ******************* Add vaccination record *******************
export const addVaccination = async (petId, vaccinationData) => {
  try {
    const response = await API.post(
      `/api/pets/${petId}/vaccinations`,
      vaccinationData
    );
    return response.data;
  } catch (error) {
    throw error?.response?.data?.message || "Failed to add vaccination record";
  }
};

// Create pet with medical details in one operation
export const createPetWithMedical = async (petData, medicalData) => {
  try {
    const combinedData = {
      ...petData,
      ...medicalData
    };
    
    const response = await API.post(`/api/pets/with-medical`, combinedData);
    return response.data;
  } catch (error) {
    throw error?.response?.data?.message || "Failed to create pet with medical details";
  }
};

// ******************* Get pets by owner ID *******************
export const getPetsByOwner = async (ownerId) => {
  try {
    const response = await API.get(`/api/pets/owner/${ownerId}`);
    return response.data;
  } catch (error) {
    throw error?.response?.data?.message || "Failed to fetch owner pets";
  }
};

// ******************* Get pets with upcoming vaccinations *******************
export const getPetsWithUpcomingVaccinations = async (days = 30) => {
  try {
    const response = await API.get(`/api/pets/upcoming-vaccinations`, {
      params: { days },
    });
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message ||
      "Failed to fetch pets with upcoming vaccinations"
    );
  }
};

// ******************* Upload pet photos *******************
export const uploadPetPhotos = async (petId, formData) => {
  try {
    const response = await API.post(`/api/pets/${petId}/photos`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    throw error?.response?.data?.message || "Failed to upload pet photos";
  }
};

// ******************* Additional utility functions *******************

// Get pets by species
export const getPetsBySpecies = async (species) => {
  try {
    const response = await API.get(`/api/pets`, {
      params: { species },
    });
    return response.data;
  } catch (error) {
    throw error?.response?.data?.message || "Failed to fetch pets by species";
  }
};

// Get pets by gender
export const getPetsByGender = async (gender) => {
  try {
    const response = await API.get(`/api/pets`, {
      params: { gender },
    });
    return response.data;
  } catch (error) {
    throw error?.response?.data?.message || "Failed to fetch pets by gender";
  }
};

// Search pets with multiple filters
export const searchPets = async (filters) => {
  try {
    const response = await API.get(`/api/pets`, { params: filters });
    return response.data;
  } catch (error) {
    throw error?.response?.data?.message || "Failed to search pets";
  }
};
